export default "__VITE_ASSET__Bzige2HG__"